(async () => {
    const posts = document.querySelectorAll('.feed__post');
    if (!posts.length) return;
    const options = {
        root: null,
        rootMargin: '60px',
        threshold: 0.1,
    };
    const copyLink = document.querySelector('.feed__client-link');
    const copyMsg = document.querySelector('.feed__client-link-msg');
    copyLink.addEventListener('click', async (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(copyLink.getAttribute('href'));
        copyMsg.classList.add('msg-active');
        setTimeout(() => copyMsg.classList.remove('msg-active'), 2000);
    });
    const observerCallback = async (entries) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const entry of entries) {
            const postItem = entry.target.querySelector(
                '.feed__page-preview--loading'
            );
            if (entry.isIntersecting && postItem) {
                const URL = postItem.dataset.link;
                const postTitle = postItem.querySelector('.feed__post-title');
                const postDescription = postItem.querySelector(
                    '.feed__post-summary'
                );
                const postLoadingSkeleton = postItem.querySelectorAll(
                    '.feed__post-details-skeleton'
                );
                const spinner = postItem.querySelector('.feed__post-spinner');
                const postImageWrapper = postItem.querySelector(
                    '.feed__post-details-image-wrapper'
                );
                try {
                    // eslint-disable-next-line no-await-in-loop
                    const preview = await fetch(
                        `https://link-preview-api-93ur.onrender.com/preview?url=${URL}`
                    );
                    // eslint-disable-next-line no-await-in-loop
                    const previewData = await preview.json();
                    if (!preview.ok) {
                        postItem.classList.remove(
                            'feed__page-preview--loading'
                        );
                        postTitle.innerHTML = 'Preview unavailable';
                        postDescription.innerHTML = '';
                        postLoadingSkeleton.forEach((skeleton) =>
                            skeleton.remove()
                        );
                        spinner?.remove();
                        const img = document.createElement('img');
                        img.setAttribute('src', './?a=16064');
                        postImageWrapper?.appendChild(img);
                        return;
                    }
                    postTitle.innerHTML =
                        previewData.title || 'Preview unavailable';
                    postDescription.innerHTML = previewData.description || '';
                    postLoadingSkeleton.forEach((skeleton) =>
                        skeleton.remove()
                    );
                    spinner?.remove();
                    const img = document.createElement('img');
                    if (previewData.thumbnail !== '') {
                        img.setAttribute('src', previewData.thumbnail);
                        postImageWrapper?.appendChild(img);
                    } else {
                        postImageWrapper.style.display = 'none';
                    }
                    postItem.classList.remove('feed__page-preview--loading');
                } catch (err) {
                    throw new Error(err);
                }
            }
        }
    };

    const iObserver = new IntersectionObserver(observerCallback, options);
    posts.forEach((post) => iObserver.observe(post));
})();
